/** Keep iOS edge Back aligned with the existing Android primary-tab fallback.
 * Discover is the app root, not another item in an invented history stack.
 */
export function primaryTabBackTarget(screen: string): 'discover' | undefined {
  return ['inbox', 'calendar', 'callHistory', 'ownProfile'].includes(screen)
    ? 'discover' : undefined;
}
